<!--
 * @Description: 份额维护审批
 * @Author: wangwangwang
 * @Date: 2020-12-02 10:46:27
 * @LastEditors  : yangxr
 * @LastEditTime : 2022-04-30 09:55:31
-->
<template>
  <div class="flows-content">
    <el-container>
      <el-main style="margin-bottom: 20px; padding: 0">
        <el-container direction="vertical">
          <FlowHeader
            :isReadOnly="readOnly"
            @saveSubmit="handleSubmit(1)"
            @sendSubmit="handleSubmit(2)"
            @handleBackEnd="handleSubmit(3)"
            @handleCC="handleSubmit(4)"
            @handleAssign="handleSubmit(5)"
            @handleBackUp="handleSubmit(6)"
            @handleAssist="handleSubmit(7)"
            @handleNode="handleSubmit(8)"
            @handleNodeImage="handleSubmit(9)"
            @handleCollection="handleSubmit(10)"
          />
          <el-main class="info">
            <div>
              <el-input v-model="title" class="flow-title" :disabled="$route.query.type * 1 !== 1" placeholder="请输入流程标题"></el-input>
            </div>
            <div class="info-top">
              <div class="left">
                <span>单据号码：{{ billCode }}</span>
                <span class="text">制单日期：{{ billDate }}</span>
              </div>
              <div class="right">
                <span>发起人：{{ applyPerson }}</span>
                <span class="text">状态：{{ taskTypeText[taskStatus * 1] }}</span>
              </div>
            </div>
            <div class="dialoginfo">
              <div class="dialoginfo-title">
                <div>
                  <span>公司：{{ formData.lotMaintain.company }}</span>
                  <span></span>
                </div>
                <div>
                  <span>站点：{{ formData.lotMaintain.station }}</span>
                  <span></span>
                </div>
              </div>
              <el-form ref="reffromDate" :inline="true" :model="formData.lotMaintain">
                <el-form-item prop="rawId">
                  <span slot="label" style="color: #ff0000">原物料名称</span>
                  <el-input v-model="formData.lotMaintain.rawName" disabled></el-input>
                </el-form-item>
                <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="formData.list" tooltip-effect="dark">
                  <el-table-column label="原物料合同编号" align="center" prop="contractNo"> </el-table-column>
                  <el-table-column label="供应商" align="center" prop="supplier"></el-table-column>
                  <el-table-column label="协作单位" align="center" prop="cooperationUnit" :min-width="140"></el-table-column>
                  <el-table-column label="已结算金额" align="center" prop="settledAmount"></el-table-column>
                  <el-table-column label="开票周期" align="center" prop="billCycle"></el-table-column>
                  <el-table-column label="周期开票金额" align="center" prop="billMoney"></el-table-column>
                  <el-table-column label="原物料" align="center">
                    <template slot-scope="scope">
                      <span>{{ scope.row.brand + formData.lotMaintain.rawName + scope.row.specification }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="品牌" align="center" prop="brand"></el-table-column>
                  <el-table-column label="规格" align="center" prop="specification"></el-table-column>
                  <el-table-column label="份额（%）" align="center">
                    <template slot-scope="scope">
                      <el-input-number v-model="scope.row.lotNum" disabled style="width: 100%" :precision="0" :controls="false" :max="100"></el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作状态" align="center">
                    <template slot-scope="scope">
                      <el-button v-if="scope.row.type !== 2" type="text" size="small" class="bottom_text">{{ ["删除数据", "新增数据"][scope.row.type] }}</el-button>
                      <el-button v-else-if="scope.row.type === 2 && scope.row.isChanged" type="text" size="small" class="bottom_text" @click="showChange(scope.row)">修改数据</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form>
            </div>
            <div class="flows-details">
              <FlowContent ref="flowcontent" :title="title" :showSendVisible="showSendVisible" @handleCancel="handleCancel" @sendCode="sendCode" @handleFinish="handleFinish" @handleBusiness="handleBusiness" />
            </div>
          </el-main>
        </el-container>
      </el-main>
    </el-container>
    <el-dialog v-dialogDrag :visible.sync="visible" width="1180px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">查看</span>
      <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="oldTableData" tooltip-effect="dark">
        <el-table-column label="原物料合同编号" align="center" prop="contractNo"> </el-table-column>
        <el-table-column label="供应商" align="center" prop="supplier"></el-table-column>
        <el-table-column label="原物料" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.brand + formData.lotMaintain.rawName + scope.row.specification }}</span>
          </template>
        </el-table-column>
        <el-table-column label="品牌" align="center" prop="brand"></el-table-column>
        <el-table-column label="规格" align="center" prop="specification"></el-table-column>
        <el-table-column label="份额（%）" align="center">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.lotNum" disabled style="width: 100%" :precision="0" :controls="false" :max="100"></el-input-number>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import FlowContent from "@/components/WorkFlow/flowContent";
import FlowHeader from "@/components/WorkFlow/flowHeader";
import { getUserInfo } from "@/utils/auth.js";
export default {
  components: {
    FlowContent,
    FlowHeader,
  },
  data() {
    return {
      type: 0,
      title: "份额维护审批",
      billCode: "",
      billDate: "",
      applyPerson: "",
      taskTypeText: ["发起", "已保存", "审批中", "已完成", "撤销", "不通过"],
      taskStatus: 0,
      showSendVisible: false,
      readOnly: false,
      visible: false,
      formData: {
        lotMaintain: {},
        list: [],
      },
      oldTableData: [],
    };
  },
  methods: {
    showChange(data) {
      const newData = this.formData.copyTableData.find(item => item.id === data.id);
      this.oldTableData = [newData];
      this.visible = true;
    },
    handleBusiness() {
      this.formData.lotMaintain.maintainStatus = 1;
      const params = {
        process_success: {
          url: "/icps/system/sign/dataCollection/lotMaintain/saveOrUpdate",
          data: {
            ...this.formData,
          },
          httpMethod: "post",
        },
        process_failure: "",
      };
      this.showSendVisible = false;
      this.$refs.flowcontent.handleToFlow(params);
    },
    /**
     * @Description:
     * @Param: 1为保存，2为最后提交/3 中间提交
     * @Author: wangwangwang
     * @param {*} type
     */
    handleFinish() {},
    handleSubmit(type) {
      const { query } = this.$route;
      if (query.type * 1 === 2 && type === 2 && query.taskType * 1 !== 2) {
        // 发起流程
        this.showSendVisible = true;
        return;
      }
      const data = {
        dataSource: "ShareMaintenance",
        dataContent: JSON.stringify({ ...this.formData, id: query.id }), // 业务数据
      };
      this.$refs.flowcontent.saveFlows(type, data);
    },
    handleFlowChat() {
      this.$refs.flowcontent.showFlowNode();
    },
    handleCancel() {
      this.showSendVisible = false;
    },
    /**
     * @Description: 回显业务数据
     * @Param:
     * @Author: wangwangwang
     */
    initFlowsData(data) {
      data.list = JSON.parse(data.list);
      data.lotMaintain = JSON.parse(data.lotMaintain);
      data.copyTableData = JSON.parse(data.copyTableData);
      this.formData = data;
      this.formatList(this.formData);
    },
    initFlowsData2() {
      const { query } = this.$route;
      const data = JSON.parse(query.dataContent);
      this.title = query.taskName;
      this.billCode = query.receiptNumber;
      this.billDate = query.createTime;
      this.applyPerson = query.createUserName;
      this.formData = data;
      this.taskStatus = query.taskStatus;
      this.formatList(this.formData);
    },
    formatList(data) {
      const newData = data.list.map(item => {
        if (item.type === 2) {
          for (let i = 0; i < data.copyTableData.length; i += 1) {
            if (item.id === data.copyTableData[i].id) {
              if (item.lotNum !== data.copyTableData[i].lotNum || item.contractId !== data.copyTableData[i].contractId || item.rawMaterialsId !== data.copyTableData[i].rawMaterialsId) {
                return { ...item, isChanged: true };
              }
            }
          }
        }
        return item;
      });
      this.formData.list = newData;
    },
    sendCode(code) {
      this.billCode = code;
    },
  },
  mounted() {
    const { query } = this.$route;
    if (query.type * 1 === 1) {
      // 发起流程
      this.initFlowsData(query);
      this.$refs.flowcontent.initBaseData("ShareMaintenance");
      this.billDate = new Date().Format("yyyy-MM-dd hh:mm:ss");
      this.applyPerson = getUserInfo().userRealName;
      return;
    }
    this.initFlowsData2();
    if (query.isReadOnly * 1 === 1) {
      this.readOnly = true;
    }
  },
};
</script>
<style lang="scss" scoped>
.flows-details {
  margin-top: 20px;
}
.info {
  padding: 0 20px;
  background: #fff;
  .info-top {
    font-size: $font_size;
    color: #000000;
    @include discen_al;
    justify-content: space-between;
    height: 50px;
    border-bottom: 1px #e1e5ed solid;
    .left {
      @include discen_al;
    }
    .text {
      margin-left: 60px;
    }
  }
}
.nav_title {
  @include discen_al;
  align-items: flex-end;
  > div {
    width: 4px;
    height: 24px;
    background: $bg_color;
    margin-right: 10px;
  }
  i {
    margin-left: 5px;
  }
  color: $bg_color;
  font-size: 20px;
  font-weight: bold;
}
.dialoginfo-title {
  display: flex;
  justify-content: space-between;
  padding: 10px 0 20px 0;
}
</style>
